import React from 'react';
import dayjs from 'dayjs';
import { formatCurrency } from '../../utils/money';
import type { ExtratoLinha } from '../../types/financeiro';

// Puramente apresentacional (ai/architecture.core.md §5) — nenhum import de service, nenhum
// hook de leitura do Apollo, nenhum fetch de dados. A consulta própria que alimenta esta lista
// vive no hook (usePendenciasFinanceiras); este componente só recebe as pendências já resolvidas.
//
// AC-9: retorna `null` quando a lista está vazia — nem um container vazio.

export interface BlocoPendenciasProps {
  pendencias: ExtratoLinha[];
  onPagar: (linha: ExtratoLinha) => void;
}

function formatDataBr(iso: string): string {
  return dayjs(iso).format('DD/MM/YYYY');
}

const ROTULO_CTA: Record<ExtratoLinha['tipo'], string> = {
  INSCRICAO: 'Pagar inscrição',
  AGENDAMENTO: 'Pagar quadra',
  REEMBOLSO: 'Ver reembolso',
};

const BlocoPendencias: React.FC<BlocoPendenciasProps> = ({ pendencias, onPagar }) => {
  if (pendencias.length === 0) {
    return null;
  }

  return (
    <div className="card border-0 shadow-xss rounded-xxl p-3 mb-3" data-testid="bloco-pendencias">
      <h6 className="fw-700 mb-2">Pendências</h6>
      <ul className="list-unstyled mb-0">
        {pendencias.map((linha) => (
          <li
            key={linha.referenciaId}
            className="d-flex justify-content-between align-items-center py-2 border-bottom"
          >
            <div>
              <div className="fw-600">{linha.descricao ?? 'Lançamento pendente'}</div>
              <div className="text-grey-500 font-xsss">
                {formatCurrency(linha.valor)} — Prazo:{' '}
                {linha.vencimento ? formatDataBr(linha.vencimento) : 'sem prazo definido'}
              </div>
            </div>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => onPagar(linha)}>
              {ROTULO_CTA[linha.tipo]}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlocoPendencias;
